import { CSSObject } from '@emotion/react'
import { fonts } from '@opallabs/pulsar'

type PostDimensionsProps = {
  [key: string]: Record<string, string>
}

const postDimensions: PostDimensionsProps = {
  mobileStandard: {
    width: '375px',
    backgroundColor: 'white',
  },
  desktopStandard: {
    width: '800px',
    backgroundColor: 'rgb(249, 249, 249)',
  },
}

const getDisplay = (display: string): CSSObject => ({
  backgroundColor: postDimensions[display].backgroundColor,
  fontFamily: fonts.helvetica,
  width: postDimensions[display].width,
})

const styles = {
  getDisplay,
}

export { styles }
